import {BackgroundJob, JobStatus} from "../../../__generated__/generated_types";

export function isJobRunning(job: BackgroundJob): boolean {
    return job.status !== JobStatus.Completed && job.status !== JobStatus.Failed;
}